<template>
  <v-btn
    block
    @click="handleExport"
    color="primary"
  >
    Exportar CSV (mes)
  </v-btn>
</template>
<script>
import api from '@/services/api'
export default {
  props: {
    workspaceID: {
      type: String,
      required: true,
    },
    query: {
      type: String,
      default: null,
    },
    pickerDate: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    loading: false,
    count: null,
    reservations: null,
  }),
  methods: {
    handleExport () {
      if (!this.pickerDate) return
      api.getAll ('booking', `v1/private/workspaces/${this.workspaceID}/reservations/csv/${this.pickerDate}`, 0, 1000000, this.query)
        .then(response => {
          window.open(response, '_blank')
        })
    },
  },
}
</script>

